import { ApiAbstract } from '../abstract';

export class ApiImportData extends ApiAbstract<any, any> {}